(function () {
    "use strict";

    angular
        .module("app")
        .directive("factoryTypeAhead", ["PrototypeService", "$compile", genderTypeAhead]);

    function genderTypeAhead(PrototypeService, $compile) {
        return {
            restrict: "E",
            link: function (scope, ele, attrs, modelCtrl) {
                PrototypeService.getFactoryCodes().then(function (response) {
                    if (response) {
                        scope.factories = response;
                        angular.forEach(response, function (item) {
                            item.DisplayText = item.FactoryName + " (" + item.FactoryKey + ")";
                        });
                        //return response;
                    }
                    //return [];
                });

                scope.setValue = function (item) {
                    scope.selectedValue = item.FactoryKey;
                };

                scope.onBlur = function () {
                    if (!scope.selectedText) {
                        scope.selectedValue = null;
                    }
                };

                scope.$watch('selectedValue', function (n) {
                    //clear out selectedText if value is null or empty
                    if (n == null || n == "") {
                        scope.selectedText = n;
                    }
                });

                //append ng-message
                scope.noResults = false;
                var noResults = angular.element('<div ng-if="noResults"><div class="error-text">Invalid Value. Your search will not include this criteria.</div></div>');
                angular.element(ele[0].parentElement).append(noResults);
                $compile(noResults)(scope);
            },
            scope: { selectedText: "=", selectedValue: "="},
            template: '<input spellcheck="false"' +
                ' placeholder="-- Search for Factory Keys --"' +
                ' uib-typeahead="item.DisplayText for item in factories | filter:$viewValue"' +
                ' ng-blur="onBlur()"' +
                ' ng-model="selectedText"' +
                ' typeahead-on-select="setValue($item)"' +
                ' typeahead-select-on-blur="true"' +
                ' typeahead-min-length="1"' +
                ' typeahead-no-results="noResults"' +
                ' class="form-control"' +
                ' aria-autocomplete="list"' +
                ' reset-field' +
                ' autocomplete="off"' +
                ' type="text"/><i class="fa fa-i-cursor edit-cursor" aria-hidden="true"></i>'
        };
    }
})();
